import Api from "@/api/Api";
import uploadWithAuth from "@/api/ApiUpload";

const RESOURCE_NAME = "/api/social_fund_applications";

// Let consumers handle failures before clearing forms or announcing success.
export default {
  getMessages(id) {
    return Api().get(RESOURCE_NAME + "/" + id + "/messages");
  },
  addMessage(id, data) {
    return Api().post(RESOURCE_NAME + "/" + id + "/messages", data);
  },
  getRecipients(params) {
    return Api().get(RESOURCE_NAME + "/recipients", { params });
  },
  sendCommunication(data) {
    return Api().post(RESOURCE_NAME + "/communications", data);
  },
  exportApplications(params) {
    return Api().get(RESOURCE_NAME + "/export", {
      params,
      responseType: "blob",
    });
  },
  getApplications(params) {
    return Api().get(RESOURCE_NAME, { params });
  },
  getApplication(id) {
    return Api().get(`${RESOURCE_NAME}/${id}`);
  },
  startReview(id) {
    return Api().post(`${RESOURCE_NAME}/${id}/start_review`);
  },
  prepareForDirectorReview(id, data) {
    return Api().post(
      `${RESOURCE_NAME}/${id}/prepare_for_director_review`,
      data,
    );
  },
  markApprovedForPayment(id, data) {
    return Api().post(`${RESOURCE_NAME}/${id}/mark_approved_for_payment`, data);
  },
  closePaid(id, data) {
    return Api().post(`${RESOURCE_NAME}/${id}/close_paid`, data);
  },
  updateApplicant(id, data) {
    return Api().patch(`${RESOURCE_NAME}/${id}/applicant`, data);
  },
  // Renombrado de /classification a /project en el backend (2026-09-29):
  // el endpoint edita datos generales del proyecto/solicitud (tipo, entidad,
  // descripción, justificación, importe), no solo "clasificación".
  updateProject(id, data) {
    // Sin .catch: el 422 (tipo no reconocido / ya resuelto por Dirección) lo maneja el componente.
    return Api().patch(`${RESOURCE_NAME}/${id}/project`, data);
  },
  updateEvaluation(id, data) {
    // Sin .catch: el 400 (importe inválido) lo maneja el componente.
    return Api().patch(`${RESOURCE_NAME}/${id}/evaluation`, data);
  },
  changeCallPeriod(id, data) {
    // Sin .catch: el componente maneja el 409 (aviso de duplicado, permite
    // reenviar con confirmDuplicate:true) y el 422 (ya resuelto por Dirección).
    return Api().patch(`${RESOURCE_NAME}/${id}/call_period`, data);
  },
  validateDocument(id, documentId, data) {
    // Sin .catch: el 422 (rejectionReason obligatorio al rechazar) lo maneja el componente.
    return Api().patch(`${RESOURCE_NAME}/${id}/documents/${documentId}`, data);
  },
  // F4 (fondo_social/v1-20260923/PLAN_FRONTEND.md): multipart, saltándose
  // Api() (que fuerza Content-Type: application/ld+json) — uploadWithAuth()
  // reintenta una vez con el token refrescado si el JWT ha caducado. Sin
  // .catch: el componente maneja 422 (validado, cerrado, tamaño) y 400.
  uploadDocument(
    id,
    { documentType, file, otherDocumentDescription, documentId, signatures },
  ) {
    const formData = new FormData();
    formData.append("documentType", documentType);
    formData.append("file", file);
    // Solo convenio: firmas que contiene el fichero (applicant|director|both).
    if (signatures) formData.append("signatures", signatures);
    if (
      otherDocumentDescription !== undefined &&
      otherDocumentDescription !== null
    ) {
      formData.append("otherDocumentDescription", otherDocumentDescription);
    }
    if (documentId !== undefined && documentId !== null) {
      formData.append("documentId", documentId);
    }
    return uploadWithAuth({
      method: "post",
      url: `${process.env.VUE_APP_BASE_URI}${RESOURCE_NAME}/${id}/documents`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
      },
    });
  },
  deleteDocument(id, documentId) {
    // Sin .catch: el 422 (tipo fijo o ya validado) lo maneja el componente.
    return Api().delete(`${RESOURCE_NAME}/${id}/documents/${documentId}`);
  },
  addComment(id, data) {
    return Api().post(`${RESOURCE_NAME}/${id}/comments`, data);
  },
  editComment(id, commentId, data) {
    return Api().put(`${RESOURCE_NAME}/${id}/comments/${commentId}`, data);
  },
  // FS-S01: descarga autenticada (blob) — documentUrl es una ruta relativa
  // devuelta por el backend (/api/social_fund_applications/{id}/documents/{docId}/download),
  // ya no una URL pública estática. Sin .catch: el componente decide qué
  // mostrar si falla.
  downloadDocument(documentUrl) {
    return Api().get(documentUrl, { responseType: "blob" });
  },
};
